import Header from "@/atomic/atoms/Header";
import { PropsView } from "./Models";

export default function TermsView({
  goBack,
}: PropsView) {
  return (
    <div className="h-full">
      <Header
        title="Termos e Condições de Uso"
        goBack={goBack}
        hasLeftButton
      />
      <main className="p-2 w-full flex justify-center h-[calc(100%-72px)] text-black h-form">
        <div className="h-full flex flex-col justify-between w-full">
          <div className="w-full h-full">
            <iframe
              src="/termos-e-condicoes.pdf"
              width="100%"
              height="100%">
            </iframe>
          </div>
        </div>
      </main>
    </div>
  );
}